<template>
  <div>
    <card-preview :card="card" class="card-preview" />
    <div class="card-detail">
      <strong>Nome no cartão: </strong> <span class="card-detail__holder-name">{{ card.holder_name }}</span>
    </div>
    <div class="card-detail">
      <strong>Validade do cartão: </strong>{{ card.expiration_month }}/{{ card.expiration_year }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card-preview {
  margin-bottom: var(--space-medium);
}

.card-detail {
  font-size: rem(16);
  line-height: rem(24);
  margin-bottom: var(--space-extra-small);

  &:last-child {
    margin-bottom: var(--space-medium);
  }
}

.card-detail__holder-name {
  text-transform: uppercase;
}
</style>

<script>
import CardPreview from './card-preview';

export default {
  props: {
    card: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    CardPreview,
  },
};
</script>
